import { differenceInDays, isBefore } from "date-fns";
import { parseDate } from "helpers";
import { ICampaignServer } from "model/campaigns";
import React from "react";
import { getRunningCampaignsList } from "redux/campaignStatus/campaignStatusSelectors";
import { useSelector } from "redux/hooks";
import { CampaignPageNotificationType, NotificationReason } from "../types";

const generateNotifications = (campaigns: Array<ICampaignServer>) => {
  const notifications: Array<CampaignPageNotificationType> = [];
  const reason = NotificationReason.campaignEndsIn3days;

  campaigns.forEach((c) => {
    if (!c.endDate) return;

    const today = new Date();

    const finishDate = parseDate(c.endDate) as Date;

    const endsInTheFuture = isBefore(today, finishDate);
    const endsSoon = differenceInDays(finishDate, today) < 3;

    if (endsInTheFuture && endsSoon) {
      notifications.push({
        id: `${c.id}_${reason}`,
        campaignId: c.id,
        campaignName: c.name,
        reason,
      });
    }
  });

  return notifications;
};

export default function useCampaignEndNotifications() {
  const campaignsList: ICampaignServer[] = useSelector(getRunningCampaignsList);

  const syncNotifications: Array<CampaignPageNotificationType> = React.useMemo(
    () => generateNotifications(campaignsList),
    [campaignsList]
  );

  return syncNotifications;
}
